import React from 'react'
import { Grid as BaseGrid, styled } from '@mui/material'
import { Card as BaseCard, TableCell as BaseTableCell } from '@chilecompra/react-kit/components'

export const Box = styled(({ children, display, flexWrap, justifyContent, padding, paddingLeft, width, ...props }) => (
  <div {...props}>{children}</div>
))`
  display: ${props => props.display};
  flex-wrap: ${props => props.flexWrap};
  flex-direction: ${props => props.flexDirection || 'initial'};
  justify-content: ${props => props.justifyContent || 'initial'};
  gap: ${props => props.gap || 'initial'};
  margin: ${props => props.margin || 'initial'};
  padding: ${props => props.padding};
  padding-left: ${props => props.paddingLeft};
  width: ${props => props.width};
`

export const Card = styled(({ children, textAlign, ...props }) => <BaseCard {...props}>{children}</BaseCard>)`
  text-align: ${props => props.textAlign};
`

export const Column = styled(({ flexGrow, margin, width, ...props }) => <BaseGrid item {...props} />)`
  &.MuiGrid-root {
    flex-grow: ${props => props.flexGrow ?? ''};
    margin: ${props => props.margin || '0'};
    width: ${props => props.width};
  }

  ${props => props.theme.breakpoints.only('xs')} {
    padding: 0;
  }

  ${props => props.theme.breakpoints.up('md')} {
    padding: 0 25px 0 0;
  }
`

export const NotFoundImg = styled('img')`
  color: ${props => props.theme.palette.gray[50]};
  height: auto;
  width: 82px;
`

export const Strong = styled('span')`
  font-weight: bold;
`

export const TableCell = styled(BaseTableCell)`
  &.MuiTableCell-root {
    padding: 16px 15px 16px 0;
    vertical-align: middle;
  }
`
